export default "__VITE_ASSET__BezSbhez__"